module.exports = __webpack_public_path__ + "static/media/icon_data-quality.87770d16.svg";